<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'Audit',
};
</script>



// WEBPACK FOOTER //
// src/view/Algorithm/Algorithm.vue